import { ButtonVariation } from 'components/atoms/button';
import { BnumConfig } from 'core/utils/BnumConfig';

export const ID_INPUT = 'bnum-input';
export const ID_HINT_TEXT = 'hint-text';
export const ID_HINT_TEXT_LABEL = 'hint-text__label';
export const ID_HINT_TEXT_HINT = 'hint-text__hint';
export const ID_INPUT_ICON = 'input__icon';
export const ID_INPUT_BUTTON = 'input__button';
export const ID_STATE = 'state';
export const ID_STATE_ICON = 'state__icon';
export const ID_SUCCESS_TEXT = 'success-text';
export const ID_ERROR_TEXT = 'error-text';

export const CLASS_STATE_TEXT_SUCCESS = 'state__text success';
export const CLASS_STATE_TEXT_ERROR = 'state__text error';

export const DEFAULT_INPUT_TYPE = 'text';
export const DEFAULT_BUTTON_VARIATION = ButtonVariation.PRIMARY;

export const SLOT_HINT = 'hint';
export const SLOT_BUTTON = 'button';
export const SLOT_SUCCESS = 'success';
export const SLOT_ERROR = 'error';

export const TEXT_VALID_INPUT =
  BnumConfig.Get('local_keys')?.valid_input || 'Le champs est valide !';
export const TEXT_INVALID_INPUT =
  BnumConfig.Get('local_keys')?.invalid_input || 'Le champs est invalide !';
export const TEXT_ERROR_FIELD =
  BnumConfig.Get('local_keys')?.error_field || 'Ce champ contient une erreur.';

export const EVENT_BUTTON_CLICK = 'bnum-input:button.click';
export const EVENT_INPUT = 'input';
export const EVENT_CHANGE = 'change';

export const ATTRIBUTE_DATA_VALUE = 'data-value';
export const ATTRIBUTE_PLACEHOLDER = 'placeholder';
export const ATTRIBUTE_TYPE = 'type';
export const ATTRIBUTE_DISABLED = 'disabled';
export const ATTRIBUTE_STATE = 'state';
export const ATTRIBUTE_BUTTON = 'button';
export const ATTRIBUTE_BUTTON_ICON = 'button-icon';
export const ATTRIBUTE_ICON = 'icon';
export const ATTRIBUTE_REQUIRED = 'required';
export const ATTRIBUTE_READONLY = 'readonly';
export const ATTRIBUTE_PATTERN = 'pattern';
export const ATTRIBUTE_MINLENGTH = 'minlength';
export const ATTRIBUTE_MAXLENGTH = 'maxlength';
export const ATTRIBUTE_AUTOCOMPLETE = 'autocomplete';
export const ATTRIBUTE_INPUTMODE = 'inputmode';
export const ATTRIBUTE_SPELLCHECK = 'spellcheck';
export const ATTRIBUTE_IGNOREVALUE = 'ignorevalue';
export const ATTRIBUTE_NAME = 'name';

export const STATE_SUCCESS = 'success';
export const STATE_ERROR = 'error';
export const STATE_DISABLED = 'disabled';
export const STATE_ICON = 'icon';
export const STATE_BUTTON = 'button';
/**
 * obi = Only Button Icon
 */
export const STATE_OBI = 'obi';
export const STATE_STATE = 'state';
export const ICON_SUCCESS = 'check_circle';
export const ICON_ERROR = 'cancel';
